export enum certificateElementType {
    Text = "Text",
    Image = 'Image',
    DynamicImage = "Dynamic Image",
    Page = "Page",
    DynamicList = "Dynamic List",
    Grid = "Grid",
    Stack = "Stack",
    Divider = "Divider",
    PageBreak = "Page Break",
    GridCell = "Grid Cell",
    DynamicModeText ="Dynamic Mode Text",
    DynamicModeImage = "Dynamic Mode Image",
    DynamicModeDynamicImage = "Dynamic Mode Dynamic Image",
    DynamicModeDynamicList = "Dynamic Mode Dynamic List",
    AdaptiveLayoutSection = "Adaptive Layout Section",
    DynamicSignature = "Dynamic Signature",
    DynamicModeDynamicSignature = "Dynamic Mode Dynamic Signature"
}